import { AfterContentInit, Component, ContentChildren, Input, QueryList, TemplateRef, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { PrimeTemplate } from '@openng/optimus-ui/api';
import { DialogModule } from '@openng/optimus-ui/dialog';

import { ButtonComponent } from '../../../../../components/kit/button/button.component';

@Component({
    selector: 'app-inner-modal',
    templateUrl: 'inner-modal.component.html',
    styleUrls: ['inner-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ButtonComponent,
        DialogModule,
        TranslatePipe,
    ],
})
export class InnerModalComponent implements AfterContentInit {

    @Input() header?: string;
    @ContentChildren(PrimeTemplate) templates!: QueryList<any>;

    buttonTemplate?: TemplateRef<any>;
    visible = false;

    ngAfterContentInit(): void {
        this.templates.forEach((item) => {
            switch (item.getType()) {
                case 'button':
                    this.buttonTemplate = item.template;
                    break;
            }
        });
    }

    show(show: boolean = true) {
        this.visible = show;
    }

}
